import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { SelectSingleWebElement } from './SelectSingleWebElement';
export { SelectSingleWebElement };

/**
 * Retrieve an instance of [SelectSingleWebElement](../classes/SelectSingleWebElement.html).
 * @example
 * ```javascript
 * import { findSelectSingle } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findSelectSingle(driver, By.id('my-oj-c-select-single'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findSelectSingle(
  driver: DriverLike,
  by: By
): Promise<SelectSingleWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type SelectSingleWebElement
  if (!(webEl instanceof SelectSingleWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'SelectSingleWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findSelectSingle(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${SelectSingleWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-select-single', SelectSingleWebElement);
